<template>
  <v-system-bar v-if="model" app color="white" class="px-4" dark height="40">
    <v-spacer />

    <!-- Tombol Klaim -->
    <v-btn class="text-capitalize font-weight-bold" color="primary" small text @click="URL('klaim')">
      Klaim
    </v-btn>

    <v-divider vertical />

    <!-- Tombol TAP -->
    <v-btn class="font-weight-bold" color="primary" small text @click="Open()">
      TAP
    </v-btn>

    <v-divider vertical />

    <!-- Tombol WhatsApp -->
    <v-btn icon @click="openWhatsApp()">
      <v-icon color="green">mdi-whatsapp</v-icon>
    </v-btn>

    <v-divider vertical />

    <!-- Ikon Globe (Pilih Bahasa) -->
    <v-btn icon>
      <v-icon color="blue">mdi-earth</v-icon>
    </v-btn>

    <v-divider vertical />

    <!-- Ruang kosong dengan lebar 50px -->
    <div class="custom-spacer"></div>
  </v-system-bar>
</template>

<script>
export default {
  name: "HomeSystemBar",

  data() {
    return {
      model: true,
    };
  },
  methods: {
    URL(id) {
      this.$router.push({ name: id });
    },
    Open() {
      window.open("https://tap.takafulumum.co.id", "_blank");
    },
    openWhatsApp() {
      const whatsappApiLink =
        "https://api.whatsapp.com/send?phone=6281119061995&text=Assalamu'alaikum%20wr%20wb%2C%20Hai%20Taka.%20Saya%20ingin%20mengetahui%20terkait%20produk%20asuransi%20di%20Takaful%20Umum.%20%0A";
      window.open(whatsappApiLink, "_blank");
    },
  },
};
</script>

<style>
.custom-spacer {
  width: 175px;
}
</style>
